import {
  FEATURE_SENTINEL_SERVICE,
  IFeatureSentinelService,
  IRequirementHandler,
} from '@ui-tool/core';
import { Observable, of } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { FeatureCodes, RequirementNames } from '@mobile-data-access-enums';

@Injectable()
export class AbleToViewBottomBarRequirementHandler
  implements IRequirementHandler
{
  //#region Properties

  public readonly name = RequirementNames.ABLE_TO_VIEW_BOTTOM_BAR;

  //#endregion

  //#region Constructor

  public constructor(
    @Inject(FEATURE_SENTINEL_SERVICE)
    protected readonly _featureSentinelService: IFeatureSentinelService
  ) {}

  //#endregion

  //#region Methods

  public shouldRequirementMetAsync(): Observable<boolean> {
    return this._featureSentinelService
      .ableToAccessFeaturesAsync([
        FeatureCodes.FF__TRACKER_MODULE,
        FeatureCodes.FF__MEDICATION_MODULE,
      ])
      .pipe(catchError(() => of(false)));
  }

  //#endregion
}
